<template>
  <span>
    <span @click="$refs.fileInput.click()">
      <slot name="content" />
    </span>

    <input
      ref="fileInput"
      type="file"
      style="display: none;"
      @change="onFileChange"
    >
  </span>
</template>
<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'


export default {
  props: {
    onChange: {
      type: Function,
      required: false,
      default: () => () => {} // Default is an empty function
    }
  },
  data() {
    return {
      test: null,
      selectedFile: null,
      newFileURL: null,
      progress: 0
    }
  },
  computed: {
    sourceURL() {
      return this.newFileURL || ''
    }
  },
  methods: {
    ...mapActions([ 'updateAuthProfile' ]),
    onFileChange(event) {
      const file = get(event, 'target.files[0]', null)

      if (this.onChange) {
        this.onChange(file)
      }
    },
  },
}
</script>
